document.addEventListener("DOMContentLoaded", function() {
  const uploadInput = document.getElementById("upload-images");
  const imagePreviewContainer = document.getElementById("image-preview");
  let selectedFiles = [];

  if (uploadInput) {
    uploadInput.addEventListener("change", function(event) {
      const newFiles = Array.from(event.target.files);

      newFiles.forEach((file) => {
        selectedFiles.push(file);
      });

      updateImagePreview();
    });
  }

  function updateImagePreview() {
    imagePreviewContainer.innerHTML = "";

    selectedFiles.forEach((file, index) => {
      const reader = new FileReader();
      reader.onload = function(e) {
        const previewItem = document.createElement("div");
        previewItem.classList.add("image-preview-item");

        const img = document.createElement("img");
        img.src = e.target.result;

        const removeButton = document.createElement("button");
        removeButton.classList.add("remove-image-button");
        removeButton.innerHTML = "&times;";

        removeButton.addEventListener("click", function() {
          selectedFiles.splice(index, 1);
          updateImagePreview();
        });

        previewItem.appendChild(img);
        previewItem.appendChild(removeButton);
        imagePreviewContainer.appendChild(previewItem);
      };
      reader.readAsDataURL(file);
    });
  }
});


